/**
 * Token storage utility — centralised auth token management.
 * Uses sessionStorage (tab-scoped) with localStorage fallback for persistence.
 * Designed for future migration to httpOnly cookies without component changes.
 */
const TOKEN_KEY = 'auth_token';

export const getToken = () => {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || null;
  } catch (e) {
    console.error("Token storage error:", e);
    return null;
  }
};

export const setToken = (token) => {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
};

export const removeToken = () => {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
};
